// Pure helpers for the app shell. No React — keep unit-testable.

/** Resolve whether a navigation item is unlocked for this tenant.
 *
 * Sidebar-module flags default to UNLOCKED for any tenant that pre-dates
 * the rollout (`integration_flags` may not yet contain the key). The
 * legacy paid add-ons (material_requests_enabled, daily_routes_enabled,
 * catalog_manager_enabled) keep their original "missing = locked"
 * semantics. We distinguish by addon-key prefix `module_`.
 */
export function isModuleUnlocked(flagKey, integrationFlags) {
  if (!flagKey) return true;
  if (!integrationFlags) return flagKey.startsWith('module_');
  if (flagKey in integrationFlags) return Boolean(integrationFlags[flagKey]);
  return flagKey.startsWith('module_');
}

/** "just now" / "5m ago" / "3h ago" / "2d ago" — used for the
 *  Aspire-last-sync timestamp under the sidebar status pill. */
export function timeAgo(dateStr) {
  if (!dateStr) return null;
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
}

/** Strip the brand suffix from `document.title` so the topbar can show
 *  just the per-page label ("Jobs", "Material Requests", etc.). */
export function pageTitleFromDocument(rawTitle) {
  return (rawTitle || '')
    .replace(/—\s*Strata x Framework.*$/, '')
    .replace(/Strata x Framework.*$/, '')
    .trim();
}
